import { render } from "./coacheItem.vue?vue&type=template&id=185e51a6&scoped=true"
import script from "./coacheItem.vue?vue&type=script&lang=js"
export * from "./coacheItem.vue?vue&type=script&lang=js"

import "./coacheItem.vue?vue&type=style&index=0&id=185e51a6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185e51a6"]])

export default __exports__